
export const authorizationConstants = {
  COMPANY_SIGNUP_REQUEST: 'COMPANY_SIGNUP_REQUEST',
  COMPANY_SIGNUP_SUCCESS: 'COMPANY_SIGNUP_SUCCESS',
  COMPANY_SIGNUP_FAILURE: 'COMPANY_SIGNUP_FAILURE',
};

export const signupSource = {
  WEB_APP: 'WEB_APP',
  SHOPIFY: 'SHOPIFY'
}

export const shopifySetupStatus = {
  APP_INSTALLED: 'APP_INSTALLED',
  APP_UNINSTALLED: 'APP_UNINSTALLED',
  SHOP_CONNECTED: 'SHOP_CONNECTED',
  RECONNECT_INITIATED: 'RECONNECT_INITIATED'
}